import styled from '@emotion/styled'
import React from 'react'
import { mq } from '../breakpoints'
import logo from '../../assets/logo.png'

export const Header = () => {
  return (
    <Container>
      <Logo
        src={logo}
        alt="MySofie"
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 10px;
  padding-bottom: 60px;
`

const Logo = styled.img`
  height: 80px;
  width: auto;

  ${mq.lg} {
    height: 120px;
  }
`
